<div class="container spacer-list">
  <div class="justify-left spacer-hr-16 layout-row space-between align-middle  header">
    <div class="layout-row align-middle">
      <span class="category-icon spacer-right-8">
        <img [src]="category.marker" [alt]="category.slug" width="32px" height="32px">
      </span>
      <h2>{{category.name}}</h2>
    </div>
    <a [href]="'./'+category.slug">View All</a>
  </div>

  <div class="layout-row flex-wrap align-center space-between articles">
    @for (item of articlesInCategory; track item; let i = $index) {
      <div class="spacer-hr-24">
        @if (i < 3) {
          <gh-snippet-mobile class="flex small" [article]="item" [size]="h3" (click)="navClick(item.title, 'category section')"></gh-snippet-mobile>
        }
      </div>
    }

  </div>
</div>
